import React, {ReactElement} from "react"

const StopIcon = (): ReactElement => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 5.5C0.75 4.09987 0.75 3.3998 1.02248 2.86502C1.26217 2.39462 1.64462 2.01217 2.11502 1.77248C2.6498 1.5 3.34987 1.5 4.75 1.5H11.75C13.1501 1.5 13.8502 1.5 14.385 1.77248C14.8554 2.01217 15.2378 2.39462 15.4775 2.86502C15.75 3.3998 15.75 4.09987 15.75 5.5V12.5C15.75 13.9001 15.75 14.6002 15.4775 15.135C15.2378 15.6054 14.8554 15.9878 14.385 16.2275C13.8502 16.5 13.1501 16.5 11.75 16.5H4.75C3.34987 16.5 2.6498 16.5 2.11502 16.2275C1.64462 15.9878 1.26217 15.6054 1.02248 15.135C0.75 14.6002 0.75 13.9001 0.75 12.5V5.5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default StopIcon
